var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import Sticky from 'react-stickynode';
import { OuterNavWrapper, StickyNavWrap, NavContent } from './styled';
class StickyContainer extends Component {
    constructor(props) {
        super(props);
        this.handleStateChange = ({ status }) => {
            const isSticky = status === 2;
            this.setState({ sticky: isSticky });
            if (window && window.localStorage)
                window.localStorage.setItem('sticky-state', isSticky.toString());
        };
        this.state = {
            sticky: false,
        };
        this.handleStateChange = this.handleStateChange.bind(this);
    }
    render() {
        const _a = this.props, { children, contrast } = _a, rest = __rest(_a, ["children", "contrast"]);
        const { sticky } = this.state;
        return (React.createElement(OuterNavWrapper, Object.assign({ sticky: sticky, contrast: contrast }, rest),
            React.createElement(Sticky, { onStateChange: this.handleStateChange },
                React.createElement(StickyNavWrap, { sticky: sticky, contrast: contrast },
                    React.createElement(NavContent, null, children)))));
    }
}
export default StickyContainer;
//# sourceMappingURL=StickyContainer.js.map